import React, { useState, useEffect } from 'react';
import { object, bool } from 'prop-types';
import { Tab, Tabs } from '../TabCustom';
import { ALERT_TYPE, DATA_TAGGER_TYPE, InputFile, REQUEST_METHOD, ShowToastMessage, useForm } from '@laramie/ui';
import { useFormErrors } from '../../hooks/useFormErrors';
import { useEntidad } from '../../hooks/useEntidad';
import { TableCustom, Loading } from '../../common';
import { CloneObject, OpenObjectURL } from '../../../utils/helpers';
import { APIS } from '../../../config/apis';
import { getDateToString, getStringMaxLength, getDateNow } from '../../../utils/convert';
import { ServerRequest } from '../../../utils/apiweb';
import MessageModal from '../MessageModal';
import FormLabel from '../FormLabel';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';
import FormError from '../FormError';
import Modal from '../Modal';
import Select from '../Select';
import {TIPS} from "../../../consts/tips";

import './index.scss';


const DataTagger = (props) => {

  // Default column widths (ingresos version: 75%/20%/95%)
  const defaultColumnWidths = {
    descripcion: '75%',
    fecha: '20%',
    detalle: '75%',
    codigo: '95%'
  };

  const columnWidths = props.columnWidths || defaultColumnWidths;

  //hooks
  const [state, setState] = useState({
      controller: {
        entidad: "",
        idEntidad: 0,
        data: {
          archivos: [],
          observaciones: [],
          etiquetas: []
        },
        addRow: (dataTaggerType, row, success, error) => {},
        removeRow: (dataTaggerType, row, success, error) => {}
      },
      loading: false,
      showMessage: false,
      showForm: false,
      modeFormEdit: false,
      rowForm: null,
      busqueda: '',
      tabActive: DATA_TAGGER_TYPE.ARCHIVO
  });

  const mount = () => {
    setState(prevState => {
      return {...prevState,
        controller: props.controller
      };
    });
  }
  useEffect(mount, [props.controller]);

  const [ formValues, formHandle, formReset, formSet ] = useForm({
    Archivo_nombre: '',
    Archivo_path: '',
    Archivo_descripcion: '',
    Archivo_idCategoriaArchivo: 0,
    Observacion_detalle: '',
    Etiqueta_codigo: ''
  });

  const { errorOf, validate, reset } = useFormErrors(getErrors, getFormatErrors);

  const [ getListEntidad, getRowEntidad ] = useEntidad({
    entidades: ['CategoriaArchivo'],
    onLoaded: (entidades, isSuccess, error) => {
      if (!isSuccess) ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
    },
    memo: {
      key: 'CategoriaArchivo',
      timeout: 0
    }
  });

  const categoriasArchivo = getListEntidad('CategoriaArchivo');
  const categoriasVigentes = categoriasArchivo.filter(f => !f.fechaBaja || new Date(f.fechaBaja) > getDateNow()).sort((a, b) => a.orden - b.orden);
  const normalizeString = (str) => String(str).normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim().toLowerCase();
  const textoBuscado = normalizeString(state.busqueda);
  const archivos = (textoBuscado.length > 0) ? state.controller.data.archivos.filter(f => [getRowEntidad('CategoriaArchivo', f.idCategoriaArchivo)?.nombre, f.descripcion, getDateToString(f.fecha, true)].some(x => x != null && normalizeString(x).includes(textoBuscado))) : state.controller.data.archivos;

  const cellAA = (data) =>  <div className='action'>
                              {!props.disabled && (
                              <div onClick={ (event) => handleClickAAdd() } className="link">
                                  <span className="material-symbols-outlined" title="Nuevo">add</span>
                              </div>
                              )}
                            </div>

  const cellADR = (data) => <div className='action'>
                              <div onClick={ (event) => handleClickADownload(data.value) } className="link">
                                  <span className="material-symbols-outlined" title="Descargar CSV">download</span>
                              </div>
                              {!props.disabled && (
                              <div onClick={ (event) => handleClickARemove(data.value) } className="link">
                                  <span className="material-symbols-outlined" title="Eliminar">delete</span>
                              </div>
                              )}
                            </div>

  const cellOA = (data) =>  <div className='action'>
                              {!props.disabled && (
                              <div onClick={ (event) => handleClickOAdd() } className="link">
                                  <span className="material-symbols-outlined" title="Nuevo">add</span>
                              </div>
                              )}
                            </div>

  const cellOVR = (data) => <div className='action'>
                              <div onClick={ (event) => handleClickOView(data.value) } className="link">
                                  <span className="material-symbols-outlined" title="Ver">search</span>
                              </div>
                              {!props.disabled && (
                              <div onClick={ (event) => handleClickORemove(data.value) } className="link">
                                  <span className="material-symbols-outlined" title="Eliminar">delete</span>
                              </div>
                              )}
                            </div>

  const cellEA = (data) =>  <div className='action'>
                              {!props.disabled && (
                              <div onClick={ (event) => handleClickEAdd() } className="link">
                                  <span className="material-symbols-outlined" title="Nuevo">add</span>
                              </div>
                              )}
                            </div>

  const cellER = (data) =>  <div className='action'>
                              {!props.disabled && (
                              <div onClick={ (event) => handleClickERemove(data.value) } className="link">
                                  <span className="material-symbols-outlined" title="Eliminar">delete</span>
                              </div>
                              )}
                            </div>

  const tableAColumns = [
    ...(categoriasArchivo.length > 0 ? [{ Header: 'Categoría', Cell: (data) => getRowEntidad('CategoriaArchivo', data.value)?.nombre ?? '', accessor: 'idCategoriaArchivo', width: '20%' }] : []),
    { Header: 'Descripción', accessor: 'descripcion', width: (categoriasArchivo.length > 0) ? '55%' : columnWidths.descripcion },
    { Header: 'Fecha', Cell: (data) => getDateToString(data.value, true), accessor: 'fecha', width: columnWidths.fecha },
    { Header: cellAA, Cell: cellADR, id:'abm', accessor: 'id', width: '5%', disableGlobalFilter: true, disableSortBy: true }
  ];
  const tableOColumns = [
    { Header: 'Detalle', Cell: (data) => getStringMaxLength(data.value, 80, ' [...]'), accessor: 'detalle', width: columnWidths.detalle },
    { Header: 'Fecha', Cell: (data) => getDateToString(data.value, true), accessor: 'fecha', width: columnWidths.fecha },
    { Header: cellOA, Cell: cellOVR, id:'abm', accessor: 'id', width: '5%', disableGlobalFilter: true, disableSortBy: true }
  ];
  const tableEColumns = [
    { Header: 'Código', accessor: 'codigo', width: columnWidths.codigo },
    { Header: cellEA, Cell: cellER, id:'abm', accessor: 'id', width: '5%', disableGlobalFilter: true, disableSortBy: true }
  ];


  //handles
  const handleClickAAdd = () => {
    const rowForm = {
      id: 0,
      entidad: state.controller.entidad,
      idEntidad: state.controller.idEntidad,
      nombre: '',
      path: '',
      descripcion: '',
      idUsuario: 0,
      fecha: null
    };
    setState(prevState => {
      return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
    });
    formReset();
  }
  const handleClickADownload = (id) => {

    const rowForm = state.controller.data.archivos.find(x => x.id === id);
    const callbackSuccess = (response) => {
      response.blob()
      .then((buffer) => {
        OpenObjectURL(rowForm.nombre, buffer);
      })
      .catch((error) => {
          const message = 'Error procesando respuesta: ' + error;
          ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
      });
    };

    const paramsHeaders = {
      "Content-Type": "application/octet-stream"
    };
    const paramsUrl = (id > 0) ? `/${rowForm.path}` : `/temp/${rowForm.path}`;
    ServerRequest(
      REQUEST_METHOD.GET,
      paramsHeaders,
      true,
      APIS.URLS.FILE,
      paramsUrl,
      null,
      callbackSuccess,
      callbackNoSuccess,
      callbackError
    );

  }
  const handleClickARemove = (id) => {
    setState(prevState => {
      const rowForm = state.controller.data.archivos.find(x => x.id === id);
      return {...prevState, showMessage: true, rowForm: rowForm};
    });
  }

  const handleClickOAdd = () => {
    const rowForm = {
      id: 0,
      entidad: state.controller.entidad,
      idEntidad: state.controller.idEntidad,
      detalle: '',
      idUsuario: 0,
      fecha: null
    };
    setState(prevState => {
      return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
    });
    formReset();
  }
  const handleClickOView = (id) => {
    const rowForm = state.controller.data.observaciones.find(x => x.id === id);
    setState(prevState => {
      return {...prevState, showForm: true, modeFormEdit: false, rowForm: rowForm};
    });
    formSet({...formValues, Observacion_detalle: rowForm.detalle});
  }
  const handleClickORemove = (id) => {
    const rowForm = state.controller.data.observaciones.find(x => x.id === id);
    setState(prevState => {
      return {...prevState, showMessage: true, rowForm: rowForm};
    });
  }

  const handleClickEAdd = () => {
    const rowForm = {
      id: 0,
      entidad: state.controller.entidad,
      idEntidad: state.controller.idEntidad,
      codigo: ''
    };
    setState(prevState => {
      return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
    });
    formReset();

  }
  const handleClickERemove = (id) => {
    const rowForm = state.controller.data.etiquetas.find(x => x.id === id);
    setState(prevState => {
      return {...prevState, showMessage: true, rowForm: rowForm};
    });
  }

  const handleUploadArchivo = (filename, data) => {
    const allowedExtensions = ['pdf', 'doc', 'docx', 'jpg', 'png']; // Lista de extensiones permitidas
    const fileExtension = filename.split('.').pop().toLowerCase();

    if (!allowedExtensions.includes(fileExtension)) {
        ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'El tipo de archivo no está permitido. Por favor, suba un archivo con una extensión válida.');
        return;
    }

    const callbackSuccess = (response) => {
      response.text()
      .then((path) => {
        formSet(prev => ({
          ...prev,
          Archivo_path: path,
          Archivo_nombre: filename
        }));
      })
      .catch((error) => {
          const message = 'Error procesando respuesta: ' + error;
          ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
      });
    };

    const paramsHeaders = {
      "Content-Type": "application/octet-stream"
    };
    ServerRequest(
      REQUEST_METHOD.POST,
      paramsHeaders,
      true,
      APIS.URLS.FILE,
      null,
      data,
      callbackSuccess,
      callbackNoSuccess,
      callbackError,
      false
    );

  }

  //callbacks
  const callbackNoSuccess = (response) => {
    response.json()
    .then((error) => {
        const message = error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
    })
    .catch((error) => {
        const message = 'Error procesando respuesta: ' + error;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
    });
  }
  const callbackError = (error) => {
      const message = 'Error procesando solicitud: ' + error.message;
      ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
  }

  //funciones
  function SetTabActive(tab) {
    setState(prevState => {
        return {...prevState, tabActive: tab};
    });
  }

  function SetBusqueda(texto) {
    setState(prevState => {
        return {...prevState, busqueda: texto};
    });
  }

  function getErrors() {

    const errors = {};

    if (state.tabActive === DATA_TAGGER_TYPE.ARCHIVO) {
      if (formValues.Archivo_nombre.length <= 0) errors.Archivo_nombre = VALIDATION_MESSAGE.REQUIRED;
      if (formValues.Archivo_descripcion.length <= 0) errors.Archivo_descripcion = VALIDATION_MESSAGE.REQUIRED;
    }
    else if (state.tabActive === DATA_TAGGER_TYPE.OBSERVACION) {
      if (formValues.Observacion_detalle.length <= 0) errors.Observacion_detalle = VALIDATION_MESSAGE.REQUIRED;
    }
    else if (state.tabActive === DATA_TAGGER_TYPE.ETIQUETA) {
      if (formValues.Etiqueta_codigo.length <= 0) errors.Etiqueta_codigo = VALIDATION_MESSAGE.REQUIRED;
    }

    return errors;
  }

  function getFormatErrors() {

    const errors = {};

    if (state.tabActive === DATA_TAGGER_TYPE.ARCHIVO) {
      if (formValues.Archivo_descripcion.length > 250) errors.Archivo_descripcion = 'No puede exceder los 250 caracteres';
    }
    else if (state.tabActive === DATA_TAGGER_TYPE.OBSERVACION) {
      if (formValues.Observacion_detalle.length > 1000) errors.Observacion_detalle = 'No puede exceder los 1000 caracteres';
    }
    else if (state.tabActive === DATA_TAGGER_TYPE.ETIQUETA) {
      if (formValues.Etiqueta_codigo.length > 50) errors.Etiqueta_codigo = 'No puede exceder los 50 caracteres';
    }

    return errors;
  }

  function AddEntidad() {

    if (!validate()) return;

    const row = CloneObject(state.rowForm);

    if (state.tabActive === DATA_TAGGER_TYPE.ARCHIVO) {
      row.nombre = formValues.Archivo_nombre;
      row.path = formValues.Archivo_path;
      row.descripcion = formValues.Archivo_descripcion;
      row.idCategoriaArchivo = formValues.Archivo_idCategoriaArchivo > 0 ? formValues.Archivo_idCategoriaArchivo : null;
      row.fecha = getDateNow(true);
      SetBusqueda('');
    }
    else if (state.tabActive === DATA_TAGGER_TYPE.OBSERVACION) {
      row.detalle = formValues.Observacion_detalle;
      row.fecha = getDateNow(true);
    }
    else if (state.tabActive === DATA_TAGGER_TYPE.ETIQUETA) {
      row.codigo = formValues.Etiqueta_codigo;
    }

    setState(prevState => {
      return {...prevState, loading: true };
    });
    state.controller.addRow(state.tabActive, row, ClosePopup, ClosePopup);
  }

  function RemoveEntidad(row) {
    setState(prevState => {
      return {...prevState, loading: true };
    });
    state.controller.removeRow(state.tabActive, row, ClosePopup, ClosePopup);
  }

  function ClosePopup() {
    reset();
    setState(prevState => {
      return {...prevState, showForm: false, rowForm: null, loading: false };
    });
  }

  const handleCloseForm = () => {
    reset();
    setState(prevState => {
      return {...prevState, showForm: false, rowForm: null};
    });
  }


  return (
  <>

    <Loading visible={state.loading}></Loading>

    {state.showMessage && 
        <MessageModal
            title={"Confirmación"}
            message={"¿Está seguro/a de borrar el registro?"}
            onDismiss={() => {
              setState(prevState => {
                  return {...prevState, showMessage: false, rowForm: null};
              });
            }}
            onConfirm={() => {
              const row = CloneObject(state.rowForm);
              setState(prevState => {
                  return {...prevState, showMessage: false, rowForm: null};
              });
              RemoveEntidad(row);
            }}
        />
    }

    {state.showForm && state.tabActive === DATA_TAGGER_TYPE.ARCHIVO &&
      <Modal
        size="md"
        title="Archivo"
        tipName={TIPS.NAME.MODALS.ARCHIVO_MODAL}
        onEscape={handleCloseForm}
        body={(
              <div className="row form-basic">

                <div className="col-12">
                  <FormLabel htmlFor="Archivo_descripcion" required>Descripción</FormLabel>
                  <input
                      name="Archivo_descripcion"
                      type="text"
                      placeholder=""
                      className={`form-control ${errorOf('Archivo_descripcion') ? 'is-invalid' : ''}`}
                      value={ formValues.Archivo_descripcion }
                      onChange={ formHandle }
                      disabled={ !state.modeFormEdit }
                  />
                  <FormError message={errorOf('Archivo_descripcion')} />
                </div>
                <div className="col-12">
                  <FormLabel htmlFor="Archivo_nombre" required>Archivo</FormLabel>
                  <InputFile
                      name="Archivo_nombre"
                      type="text"
                      placeholder="Click para adjuntar un archivo..."
                      className={`form-control ${errorOf('Archivo_nombre') ? 'is-invalid' : ''}`}
                      value={ formValues.Archivo_nombre }
                      onUpload={ handleUploadArchivo }
                      disabled={ !state.modeFormEdit }
                  />
                  <FormError message={errorOf('Archivo_nombre')} />
                </div>
                {categoriasVigentes.length > 0 &&
                <div className="col-6">
                  <FormLabel htmlFor="Archivo_idCategoriaArchivo">Categoría</FormLabel>
                  <Select
                      name="Archivo_idCategoriaArchivo"
                      className="form-control"
                      value={ formValues.Archivo_idCategoriaArchivo }
                      options={categoriasVigentes.map(item => ({ value: item.id, label: item.nombre }))}
                      emptyOption="Sin selección"
                      emptyValue={0}
                      onChange={ formHandle }
                      disabled={ !state.modeFormEdit }
                  />
                  <FormError />
                </div>
                }

              </div>
        )}
        footer={(<>
              <button
                className="btn btn-outline-primary" data-dismiss="modal"
                onClick={ (event) => handleCloseForm() }
              >Cancelar</button>
              {state.modeFormEdit &&
              <button
                className="btn btn-primary" data-dismiss="modal"
                onClick={ (event) => {
                  AddEntidad();
                }}
              >Aceptar</button>
              }
        </>)}
      />
    }

    {state.showForm && state.tabActive === DATA_TAGGER_TYPE.OBSERVACION &&
      <Modal
        size="md"
        title="Observación"
        tipName={TIPS.NAME.MODALS.OBSERVACION_MODAL}
        onEscape={handleCloseForm}
        body={(
              <div className="row form-basic">

                <div className="col-12">
                  <FormLabel htmlFor="Observacion_detalle" required>Detalle</FormLabel>
                  <textarea
                      name="Observacion_detalle"
                      placeholder=""
                      className={`form-control ${errorOf('Observacion_detalle') ? 'is-invalid' : ''}`}
                      value={ formValues.Observacion_detalle }
                      onChange={ formHandle }
                      disabled={ !state.modeFormEdit }
                      rows="4"
                  />
                  <FormError message={errorOf('Observacion_detalle')} />
                </div>

              </div>
        )}
        footer={state.modeFormEdit ? (<>
              <button
                className="btn btn-outline-primary" data-dismiss="modal"
                onClick={ (event) => handleCloseForm() }
              >Cancelar</button>
              <button
                className="btn btn-primary" data-dismiss="modal"
                onClick={ (event) => {
                  AddEntidad();
                }}
              >Aceptar</button>
        </>) : (
                  <button
                    className="btn back-button" data-dismiss="modal"
                    onClick={ (event) => handleCloseForm() }
                  >Volver</button>
        )}
        footerClassName={state.modeFormEdit ? '' : 'f-align'}
      />
    }

    {state.showForm && state.tabActive === DATA_TAGGER_TYPE.ETIQUETA &&
      <Modal
        size="md"
        title="Etiqueta"
        tipName={TIPS.NAME.MODALS.ETIQUETA_MODAL}
        onEscape={handleCloseForm}
        body={(
              <div className="row form-basic">

                <div className="col-12">
                  <FormLabel htmlFor="Etiqueta_codigo" required>Código</FormLabel>
                  <input
                      name="Etiqueta_codigo"
                      type="text"
                      placeholder=""
                      className={`form-control ${errorOf('Etiqueta_codigo') ? 'is-invalid' : ''}`}
                      value={ formValues.Etiqueta_codigo }
                      onChange={ formHandle }
                      disabled={ !state.modeFormEdit }
                  />
                  <FormError message={errorOf('Etiqueta_codigo')} />
                </div>

              </div>
        )}
        footer={(<>
              <button
                className="btn btn-outline-primary" data-dismiss="modal"
                onClick={ (event) => handleCloseForm() }
              >Cancelar</button>
              {state.modeFormEdit &&
              <button
                className="btn btn-primary" data-dismiss="modal"
                onClick={ (event) => {
                  AddEntidad();
                }}
              >Aceptar</button>
              }
        </>)}
      />
    }

    <Tabs
      id="tabs-datatagger"
      activeKey={state.tabActive}
      className="m-top-20"
      onSelect={(tab) => SetTabActive(tab)}
    >

      <Tab eventKey={DATA_TAGGER_TYPE.ARCHIVO} title="Archivos">
          <div className='tab-panel'>
            {categoriasArchivo.length > 0 &&
            <div className="data-tagger-filter">
              <FormLabel htmlFor="busqueda">Buscar</FormLabel>
              <input
                  name="busqueda"
                  type="text"
                  placeholder=""
                  className="form-control"
                  value={ state.busqueda }
                  onChange={ (event) => SetBusqueda(event.target.value) }
                  autoComplete="off"
              />
            </div>
            }
            <TableCustom
                showFilterGlobal={false}
                floatingDownloadCSVButton={categoriasArchivo.length > 0}
                className={'TableCustomBase'}
                columns={tableAColumns}
                data={archivos}
                messageEmpty={(state.controller.data.archivos.length > 0) ? "No se encontraron resultados" : "Aún no hay archivos cargados"}
            />
          </div>
      </Tab>
      <Tab eventKey={DATA_TAGGER_TYPE.OBSERVACION} title="Observaciones">
          <div className='tab-panel'>
            <TableCustom
                showFilterGlobal={false}
                className={'TableCustomBase'}
                columns={tableOColumns}
                data={state.controller.data.observaciones}
                messageEmpty="Aún no hay observaciones cargadas"
            />
          </div>
      </Tab>
      <Tab eventKey={DATA_TAGGER_TYPE.ETIQUETA} title="Etiquetas">
          <div className='tab-panel'>
            <TableCustom
                showFilterGlobal={false}
                className={'TableCustomBase'}
                columns={tableEColumns}
                data={state.controller.data.etiquetas}
                messageEmpty="Aún no hay etiquetas cargadas"
            />
          </div>
      </Tab>

    </Tabs>

  </>
  );
}

DataTagger.propTypes = {
  disabled: bool,
  controller: object.isRequired,
  columnWidths: object
};

DataTagger.defaultProps = {
  disabled: false,
  columnWidths: {
    descripcion: '75%',
    fecha: '20%',
    detalle: '75%',
    codigo: '95%'
  }
};

export default DataTagger;